// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-header.actions{display:flex;justify-content:flex-end;align-items:center;padding:0 10px}.widgets{background-color:#fff}", ""]);
// Exports
module.exports = exports;
